export default "__VITE_ASSET__CL0zBYXj__"